// pages/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';
import usePageTitle from '../../hooks/usePageTitle';
import '../Detail.css';

const NotFound = () => {
    usePageTitle('Page Not Found');

    return (
        <section className="section not-found">
            <div className="container">
                <div className="not-found-code">404</div>
                <h1>Page not found</h1>
                <p>The page you are looking for doesn't exist or has been moved.</p>
                <div className="not-found-actions">
                    <Link to="/" className="btn">Back to Home</Link>
                    <Link to="/portfolio" className="btn btn-outline">View Our Work</Link>
                </div>
            </div>
        </section>
    );
};

export default NotFound;
